var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('a-row',{staticStyle:{"margin-top":"20px"}},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title[_vm.$i18n.locale]))])]),_c('imageStore')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }